export default Object.freeze({
  xs: 360,
  sm: 545,
  md: 767,
  lg: 1024,
  xl: 1280,
  xxl: 1440,
});
